module.exports = "<span class=\"heartStyle\" *ngIf=\"visible\">\r\n    {{getHearts()}}\r\n</span>"